import { RequireAtLeastOne } from "../../../utils/typesHelpers";

export const RoutePutBasePogSelectedStatus = "/pogger/base_pog/status";

export type PayloadPutBasePogSelectedStatus = RequireAtLeastOne<{
  is_favourite?: number[]; // list of base_pog_ids
  is_not_favourite?: number[];
}>;
